const styles = {
  '.entity__shield': {
    bgColor: 'global.body.bg',
    borderColor: 'global.body.bg',
  },
};

export default styles;
